import PropTypes from 'prop-types';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
} from '@chakra-ui/react';

function StayOnPageModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  stayButtonText,
  proceedButtonText,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{message}</Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="gray" mr={3} onClick={onClose}>
            {stayButtonText}
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            {proceedButtonText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

StayOnPageModal.defaultProps = {
  stayButtonText: 'Stay on Page',
  proceedButtonText: 'Proceed',
};

StayOnPageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  stayButtonText: PropTypes.string,
  proceedButtonText: PropTypes.string,
};

export default StayOnPageModal;
